import { memo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useProgress } from "../contexts/progress-context";
import { useMerchantInfo } from "../hooks/use-merchant-info";
import { useProduct } from "../hooks/use-product";

export const ProductRedirect = memo(function ProductRedirect() {
  const product = useProduct();
  const location = useLocation();
  const { currentStepId } = useProgress();
  const { featureFlags, loading } = useMerchantInfo();

  if (!product) {
    return <Navigate replace to="/" />;
  }

  if (
    product.id === "shipping-fulfillment" &&
    featureFlags == null &&
    loading
  ) {
    return null;
  }

  let targetStep = product.defaultRoute;
  if (currentStepId) {
    const validStep = product.steps.find((s) => s.id === currentStepId);
    if (validStep) {
      targetStep = validStep.path;
    }
  }

  return (
    <Navigate
      replace
      state={location.state}
      to={`/${product.id}/${targetStep}${location.search}`}
    />
  );
});
